import React from 'react';
import { useGetOtpModalAlertState, useGetOtpModalStep, useResetModalOtpData } from '../../../../../stores/otpModal.store';
import SendFormBtm from '../../../../../components/buttons/SendFormBtm';
import useOtpModalFunctions from '../../../../../hooks/useOtpModalFunctions';
import Button from '../../../../../components/buttons/Button';
import { ArrowClockwise } from 'react-bootstrap-icons';
import useTags from '../../../../../hooks/useTags';
import otpModalLang from '../../../../../data/lang/homePage/otpModal.lang';


const OtpFormButtons = () => {

    const { handleSendOtpCode, handleCheckOtpCode } = useOtpModalFunctions();
    const resetForm = useResetModalOtpData();
    const step = useGetOtpModalStep();
    const alertState = useGetOtpModalAlertState();

    const isLoading = alertState.alertStatus === 'loading';


    const generateTag = useTags();
    const sendCodeLabelTag = generateTag(otpModalLang, 'form.btns.send-otp-code');
    const checkCodeLabelTag = generateTag(otpModalLang, 'form.btns.check-otp-code');
    const resetFormLabelTag = generateTag(otpModalLang, 'form.btns.reset-form-details');

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', gap: '8px' }}>

            {/* Send Otp Code To Mobile Btn */}
            <SendFormBtm show={step === 'pre-otp-input'} btnLabel={sendCodeLabelTag}
                isLoading={isLoading} onClick={handleSendOtpCode} />

            {/* Reset Permit Details Btn */}
            <Button show={step === 'otp-input'} text={resetFormLabelTag}
                theme='secondary' onClick={resetForm}
                endIcon={<ArrowClockwise />} isLoading={isLoading} />

            {/* Check Otp Code From Mobile Btn */}
            <SendFormBtm show={step === 'otp-input'} btnLabel={checkCodeLabelTag}
            isLoading={isLoading} onClick={handleCheckOtpCode} />

        </div>
    );
}

export default OtpFormButtons;